import React from 'react';

import { MainView, NoAccessView } from '@repo/ui/Views';
import { POLICIES } from '@/lib/Authorization';
import TcrQuickLinks from '../components/TcrQuickLink';
import { useUser } from '@repo/hooks/useUser';

const Tcr = () => {
  const user = useUser();

  return POLICIES['csp_brands:index'](user) || POLICIES['csp_campaigns:index'](user) ? (
    <MainView title="The Campaign Registry">
      <TcrQuickLinks />
    </MainView>
  ) : (
    <NoAccessView />
  );
};

export default Tcr;
